import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Box,
    Typography,
    CircularProgress,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import { formatDateTime } from '../../lib/dateFormat';

const ApiLogs = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLogs = async () => {
        try {
            const res = await axios.get('/api/vapi/api-logs');
            setLogs(res.data);
        } catch (err) {
            setError('Failed to fetch API logs');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom>
                <SatelliteAltIcon sx={{ mr: 1 }} />
                API Logs
            </Typography>

            {loading && <CircularProgress />}
            {error && <Typography color="error">{error}</Typography>}

            {!loading && !error && (
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Agent</TableCell>
                                <TableCell>Tool</TableCell>
                                <TableCell>URL</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Time (ms)</TableCell>
                                <TableCell>Timestamp</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map((log) => (
                                <TableRow key={log.id}>
                                    <TableCell>{log.agent?.name || log.agent_id}</TableCell>
                                    <TableCell>{log.tool?.name || '—'}</TableCell>
                                    <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {log.url}
                                    </TableCell>
                                    <TableCell>{log.status_code}</TableCell>
                                    <TableCell>{log.duration_ms}</TableCell>
                                    <TableCell>{formatDateTime(log.created_at)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            )}
        </Box>
    );
};

export default ApiLogs;
